import axios from 'axios';
import { getToken } from './auth';

function isNativePlatform(): boolean {
  try {
    const w: any = typeof window !== 'undefined' ? window : undefined;
    if (!w) return false;
    if (w.Capacitor?.isNativePlatform?.()) return true;
    const protocol = String(w.location?.protocol || '');
    return protocol === 'capacitor:' || protocol === 'file:';
  } catch {
    return false;
  }
}

const webBaseURL = String(import.meta.env.VITE_API_BASE_URL_WEB || '').trim();
const nativeBaseURL = String(import.meta.env.VITE_API_BASE_URL || '').trim();
const baseURL = isNativePlatform()
  ? nativeBaseURL || webBaseURL || 'http://10.0.2.2:8000'
  : webBaseURL || nativeBaseURL || '';

export const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
